import Vue from 'vue'
import VueI18n from 'vue-i18n'
import { Locale } from 'vant'
import en from 'vant/lib/locale/lang/en-US'
import zhCN from 'vant/lib/locale/lang/zh-CN'
import zhHK from 'vant/lib/locale/lang/zh-HK' //vant 自带国际化繁体包
// import enLocale from './en_us'
import commonZhLocale from './common/zh_cn'
import commonTcLocale from './common/zh_tc'
import commonEnLocale from './common/en_us'
import { getLangType } from '@/utils/tools.js'
const { VUE_APP_ENV = 'sit' } = process.env
Vue.use(VueI18n)

/** 全局英文开关：仅 SIT 启用，其他业务模块沿用此规则 */
export const kEnglishEnabled = VUE_APP_ENV === 'sit'
/** ESOP 开户英文开关：全环境启用 */
export const kEsopEnglishEnabled = true

// 更新vant组件库本身的语言变化，支持国际化
export const vantLocales = (lang = getLangType(), englishEnabled = kEnglishEnabled) => {
    if (englishEnabled && lang === 'en') {
        Locale.use(lang, en)
    } else if (lang === 'zhCn') {
        Locale.use('zh-CN', zhCN)
    } else if (lang === 'zhTc') {
        Locale.use('zh-HK', zhHK)
    } else {
        Locale.use('zh-CN', zhCN)
    }
}

/**
 * 实例化i18n
 * @param {*} options
 * @param {Object} options.zhLocale 项目的简体语言
 * @param {Object} options.tcLocale 项目的繁体语言
 * @param {Object} options.enLocale 项目的英文语言（暂时不支持
 * @param {Object} options.zhCn 项目的简体语言 - 需要自己传入公共语言库
 * @param {Object} options.zhTc 项目的繁体语言 - 需要自己传入公共语言库
 * @param {Object} options.en 项目的英文语言 - 需要自己传入公共语言库（暂不支持
 * @param {boolean} options.englishEnabled 是否注册英文语言包，默认跟随 kEnglishEnabled
 * @returns { Object } i18n实例
 */
export default function initI18n(options = {}) {
    let { zhCn, zhTc, en } = options
    const { zhLocale = {}, tcLocale = {}, enLocale = {}, getLang, defaultLang = 'zhCn', englishEnabled = kEnglishEnabled } = options
    // 支持外部整体传入
    zhCn = zhCn || {
        ...zhLocale,
        ...commonZhLocale,
    }
    zhTc = zhTc || {
        ...tcLocale,
        ...commonTcLocale,
    }
    en = en || {
        ...enLocale,
        ...commonEnLocale,
    }
    const messages = {
        zhCn,
        zhTc,
    }
    if (englishEnabled) {
        messages.en = en
    }
    const i18n = new VueI18n({
        locale: getLang?.() ?? getLangType(), // 设置默认语言
        messages: messages, // 设置资源文件对象
        fallbackLocale: defaultLang,
    })

    // 初始化vant组件多语言
    vantLocales(getLang?.() ?? getLangType(), englishEnabled)

    return i18n
}
